<template>
  <Navbar />
  <main id="main-content" tabindex="-1">
    <slot />
  </main>
  <Footer />
</template>

<script setup>
const config = useRuntimeConfig();
// const Navbar = defineAsyncComponent(() => import("~/components/Navbar.vue"));
// const Footer = defineAsyncComponent(() => import("~/components/Footer.vue"));
useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Travvir",
        url: config.public.NUXT_BASE_URL,
        foundingDate: "2021",
        founders: [
          {
            "@type": "Person",
            name: "Rohan mittal",
          },
        ],
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support", //change according to need in production
          telephone: "*********", //add our actual phone number in production
          email: "rohan@travvir.com",
        },
        sameAs: [
          "https://www.instagram.com/travvir", //add our actual facebook link in production
          "https://www.linkedin.com/company/travvir/",
          "https://x.com/Travvir_AI",
        ],
      }),
    },
  ],
});
</script>

<style lang="scss" scoped></style>
